import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

const Hero = ({ onOrderClick }) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        
        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20">
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://images.unsplash.com/photo-1605098293544-25f4c32344c8" 
          alt="Background" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
              🔥 Limited Time Offer
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Turn Walk-Ins Into <span className="text-green-500">WhatsApp Leads</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8">
              Premium QR Stand + Stickers that convert every customer into a repeat buyer on WhatsApp
            </p>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 mb-8">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="text-gray-400 text-sm">Special Price</p>
                  <p className="text-4xl font-bold text-green-400">₹1,999</p>
                </div>
                <div className="text-right">
                  <p className="text-gray-400 text-sm line-through">Regular: ₹7,999</p>
                  <p className="text-green-400 font-semibold">Save 75%</p>
                </div>
              </div>
              
              <div className="bg-red-600 text-white p-4 rounded-lg mb-4">
                <p className="text-sm font-semibold mb-2">⏰ Offer Ends In:</p>
                <div className="flex gap-4 justify-center text-center">
                  <div>
                    <div className="text-3xl font-bold">{String(timeLeft.hours).padStart(2, '0')}</div>
                    <div className="text-xs">Hours</div>
                  </div>
                  <div className="text-3xl font-bold">:</div>
                  <div>
                    <div className="text-3xl font-bold">{String(timeLeft.minutes).padStart(2, '0')}</div>
                    <div className="text-xs">Minutes</div>
                  </div>
                  <div className="text-3xl font-bold">:</div>
                  <div>
                    <div className="text-3xl font-bold">{String(timeLeft.seconds).padStart(2, '0')}</div>
                    <div className="text-xs">Seconds</div>
                  </div>
                </div>
              </div>

              <button
                onClick={onOrderClick}
                className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105"
                data-testid="hero-order-button"
              >
                🚀 Order Your Kit Now
              </button>
            </div>

            <div className="flex items-center gap-6 text-sm">
              <div className="flex items-center gap-2">
                <span className="text-green-400">✓</span>
                <span>30-Day Money Back</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-green-400">✓</span>
                <span>500+ Happy Businesses</span>
              </div>
            </div>
          </div>

          <div className="relative">
            {/* YouTube Video Player with React Player Plugin */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10 mb-6">
              <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-green-500">
                <ReactPlayer
                  url="https://youtube.com/shorts/x7SaL4l-gOw"
                  playing={playing}
                  controls={true}
                  width="100%"
                  height="500px"
                  style={{ borderRadius: '0.75rem' }}
                  config={{
                    youtube: {
                      playerVars: {
                        showinfo: 1,
                        modestbranding: 1,
                        rel: 0,
                        fs: 1
                      }
                    }
                  }}
                  onPlay={() => {
                    setPlaying(true);
                    // Track video play event
                    if (window.dataLayer) {
                      window.dataLayer.push({
                        'event': 'video_play',
                        'video_location': 'hero_section',
                        'video_id': 'x7SaL4l-gOw'
                      });
                    }
                  }}
                  onPause={() => setPlaying(false)}
                />
              </div>
              <div className="mt-4 text-center">
                <p className="text-white font-semibold text-lg mb-2">
                  ▶️ Watch: How AIQR Kit Transforms Your Business in 30 Seconds
                </p>
                <p className="text-green-300 text-sm">
                  See real results • 500+ businesses trust us • Zero tech knowledge needed
                </p>
                {!playing && (
                  <button
                    onClick={() => setPlaying(true)}
                    className="mt-3 bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg font-semibold transition-all inline-flex items-center gap-2"
                  >
                    <span>▶</span>
                    <span>Play Video</span>
                  </button>
                )}
              </div>
            </div>

            {/* Product Features */}
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="bg-green-500 w-3 h-3 rounded-full animate-pulse"></div>
                  <p className="text-sm">Premium Acrylic QR Stand (4"x6")</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-green-500 w-3 h-3 rounded-full animate-pulse"></div>
                  <p className="text-sm">High-Quality Vinyl Stickers (3"x3")</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-green-500 w-3 h-3 rounded-full animate-pulse"></div>
                  <p className="text-sm">Setup in 30 Seconds - Zero Tech Knowledge</p>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-green-500 w-3 h-3 rounded-full animate-pulse"></div>
                  <p className="text-sm">Works Forever - No Monthly Fees</p>
                </div>
              </div>
            </div>
            
            <div className="absolute -bottom-4 -right-4 bg-red-600 text-white px-6 py-3 rounded-lg font-bold shadow-lg animate-bounce z-10">
              Only 23 Left!
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;